export const Text = {
    "contact": "We love hearing from our users and are always happy to answer any questions you may have about our product. Our team is standing by and can't wait to hear from you.",
    "open": "Monday - Friday: 9am-5:30pm (GMT)",
    "call": "We're just a phone call away! Reach out to us with any questions you have at 03455-481311",
    "email": ["Have a question? Shoot us an email at support@vieutopia.com and our team will be happy to help! We aim to respond to all emails within 72 hours.",],
    "office":["Vieunite Limited","Woodgate Business Park","38 Kettles Wood Dr","Birmingham","B32 3DB"],
}
